import { Skeleton } from '@onbeef/components/skeleton';
import { Link } from 'react-router-dom';
import StarList from '../../../assets/images/favorite.png';
import { useSlug } from '../../../hooks/useSlug';
import { useMerchantCache } from '../../../queries/home';
import { useAuthStore } from '../../../stores/login';
import { useMerchantStore } from '../../../stores/merchant';

export const LoyaltyDetailWelcoming = () => {
  const params = useSlug();
  const { isLoading } = useMerchantCache(params.slug);

  const merchantLoyaltyProgramme = useMerchantStore(
    (state) => state.loyalty_programme,
  );

  const user = useAuthStore((state) => state.user);

  return (
    <Skeleton
      isLoading={isLoading}
      repeatQuantity={3}
      className="w-full h-10 rounded-xl"
    >
      <div className="flex flex-col p-5 space-y-6 bg-white rounded-t-3xl">
        <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
          <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-xl">🎉</span>
          </div>
          <h2 className="text-xl font-semibold">Bem-vindo(a), {user?.name}!</h2>
        </div>

        <div className="space-y-4">
          <p className="text-gray-600">
            Agora você faz parte do nosso clube de fidelidade! Confira seus
            benefícios exclusivos:
          </p>
          <div className="bg-gray-50 p-4 rounded-xl space-y-3 divide-y divide-gray-200">
            {merchantLoyaltyProgramme?.messages?.map((message, i) => (
              <div
                className="flex items-start gap-3 pt-3 first:pt-0"
                key={`message-${i}`}
              >
                <img src={StarList} className="h-5 w-5 mt-1" alt="Estrela" />
                <p className="font-medium text-gray-800">{message}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4 pt-2">
          <p className="text-gray-600 text-center">
            Faça seu primeiro pedido e comece a ganhar pontos!
          </p>
          <Link
            className="block w-full text-center bg-primary hover:bg-primary/90 transition-colors text-white p-3 rounded-xl font-semibold"
            to="/"
          >
            Fazer um pedido
          </Link>
        </div>
      </div>
    </Skeleton>
  );
};
